import React from 'react';
import { Button, Form, Input, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { FORM_NOT_EMPTY_RULE, FORM_UUID_RULE } from '../../../../../utils';
import { PaddedButton } from '../styles';
import { ERROR_MESSAGES, LAYOUT_STYLES, TAIL_STYLES } from '../constants';

const AccountProfileForm = ({ form, onSubmit, onBack }) => {
  return (
    <Form {...LAYOUT_STYLES} form={form} onFinish={onSubmit}>
      <Form.Item
        label="Account Id"
        name="accountId"
        rules={[{ required: true, message: ERROR_MESSAGES.REQUIRED_ACCOUNT_ID }, FORM_UUID_RULE]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Profile Id"
        name="profileId"
        rules={[{ required: true, message: ERROR_MESSAGES.REQUIRED_PROFILE_ID }, FORM_UUID_RULE]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={
          <span>
            Nickname&nbsp;
            <Tooltip title="Customize Profile Nickname: Links to your Profile, not the Account">
              <InfoCircleOutlined />
            </Tooltip>
          </span>
        }
        name="nickname"
        rules={[{ required: true, message: ERROR_MESSAGES.REQUIRED_NICKNAME }, FORM_NOT_EMPTY_RULE]}
      >
        <Input />
      </Form.Item>
      <Form.Item {...TAIL_STYLES}>
        <Button onClick={onBack}>Back</Button>
        <PaddedButton type="primary" htmlType="submit">
          Submit
        </PaddedButton>
      </Form.Item>
    </Form>
  );
};

export default AccountProfileForm;
